import "./AddHomeBtn.css"
const AddHomeLinfoBtn = () => {
    return (
        <div className="addHomeBtn">
            <button>Add hodlinfo to home screen</button>
        </div>
      );
}
 
export default AddHomeLinfoBtn;